
export const Variables = `
declare class Variables {
    set(name: string, value: any): void
} 

interface TaskService {
    complete: (task: any, variables: Variables) => void
};
`

export const funcVaraible =`
declare function addVariable(name: string, value:any, type?: string, valueInfo?: any): Promise<any>;
declare function updateVariable(name: string, value:any, type?: string, valueInfo?: any): Promise<any>;
declare function deleteVariable(name: string): Promise<any>;
declare function getVariables(): Promise<any>;
declare var bindParams: Object;
`